export default "/media/vaccine_chart_img.png";